import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Alert,
    Button,
    Typography,
    IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Google, Microsoft } from "@mui/icons-material";
import { GoogleAuthProvider, OAuthProvider, signInWithPopup } from "firebase/auth";

import LoadingAnimation from "../loaders/animations/CrossLoadingAnimation";
import { auth } from "./firebase-config";
import { useAuth } from "../../../hooks/useAuth";

export default function LoginOptionsDialog({ open, onClose, layout = "fullscreen" }) {
    const { login } = useAuth();
    const [disableLogin, setDisableLogin] = React.useState(false);
    const [loginFailed, setLoginFailed] = React.useState(null);

    const microsoftProvider = new OAuthProvider("microsoft.com");
    const googleProvider = new GoogleAuthProvider();

    const signInWithProvider = (provider) => {
        setDisableLogin(true);
        setLoginFailed(null);
        signInWithPopup(auth, provider)
            .then((result) => {
                login(result.user.accessToken, "/firebase");
            })
            .catch((error) => {
                setDisableLogin(false);
                setLoginFailed(error.message);
            });
    };

    const providers = [
        {
            name: "Google",
            provider: googleProvider,
            icon: Google,
            disabled: false,
        },
        {
            name: "Microsoft",
            provider: microsoftProvider,
            icon: Microsoft,
            disabled: true,
        },
    ];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={layout === "fullscreen"}
        >
            <DialogTitle>
                Login
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" sx={{ py: 0.5 }}>
                    Choose a provider to login to the application.
                </Typography>
                {loginFailed && (
                    <Alert
                        severity="error"
                        action={
                            <Button
                                color="inherit"
                                size="small"
                                onClick={() => alert(loginFailed)}
                            >
                                details
                            </Button>
                        }
                        sx={{ mb: 2 }}
                    >
                        Login failed, please try again.
                    </Alert>
                )}
                <List>
                    {disableLogin && <LoadingAnimation />}
                    {!disableLogin &&
                        providers.map((provider, index) => (
                            <React.Fragment key={index}>
                                {index !== 0 && <Divider component="li" />}
                                <ListItem
                                    button
                                    onClick={() => signInWithProvider(provider.provider)}
                                    disabled={provider.disabled}
                                    sx={{
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "action.hover",
                                        },
                                    }}
                                >
                                    <ListItemIcon>
                                        <provider.icon />
                                    </ListItemIcon>
                                    <ListItemText primary={provider.name} />
                                </ListItem>
                            </React.Fragment>
                        ))}
                </List>
            </DialogContent>
        </Dialog>
    );
}
